import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import colorSharp from "../assets/img/color-sharp.png";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Programming Skills</h2>
              <p>
                I am a full stack web developer with a diverse set of skills
                ranging from front-end to back-end development. My expertise
                lies in creating responsive and visually appealing websites,
                developing strong brand identities, and crafting unique logos
                that leave a lasting impression. With a keen eye for detail and
                a passion for innovation, I strive to deliver high-quality work
                that meets the needs of my clients.
              </p>
              <Carousel
                responsive={responsive}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={3000}
                className="owl-carousel owl-theme skill-slider"
              >
                <div className="item">
                  <img src={meter1} alt="Java" />
                  <h5>Java</h5>
                </div>
                <div className="item">
                  <img src={meter2} alt="Python" />
                  <h5>Python</h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="C/C++" />
                  <h5>C/C++</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="HTML/CSS" />
                  <h5>HTML/CSS</h5>
                </div>
                <div className="item">
                  <img src={meter2} alt="PHP" />
                  <h5>PHP</h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="JavaScript" />
                  <h5>JavaScript</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="React JS" />
                  <h5>React JS</h5>
                </div>
                <div className="item">
                  <img src={meter2} alt="React JS" />
                  <h5>React JS</h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="Node JS" />
                  <h5>Node JS</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Express JS" />
                  <h5>Express JS</h5>
                </div>
                <div className="item">
                  <img src={meter2} alt="XML" />
                  <h5>XML</h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="Angular" />
                  <h5>Angular</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="React Native" />
                  <h5>React Native</h5>
                </div>
                <div className="item">
                  <img src={meter2} alt="Kotlin" />
                  <h5>Kotlin</h5>
                </div>
                <div className="item">
                  <img src={meter3} alt=".NET" />
                  <h5>.NET</h5>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img
        className="background-image-left"
        src={colorSharp}
        alt="Background"
      />
    </section>
  );
};
